module.exports = __webpack_public_path__ + "static/media/puzzle-6-bg.cb6fb999.svg";